module.exports = __webpack_public_path__ + "static/media/001-cape.edda3db8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/001-cape.png
// module id = 650
// module chunks = 0